// libs
import React, { memo } from 'react';
import { useSelector } from 'react-redux';

// components
import Search from './components/Search';
import Auth from './components/Auth';
import Cart from './components/Cart';
import WishList from './components/Wishlist';
import StoreToggle from './components/StoreToggle';
import StoreToggleCoachmark from './components/StoreToggleCoachmark';

// styled
import { Container } from './styles';

// redux
import { getStoreId } from 'shared/store/app/selectors';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

// defs
interface IHeaderActionProps {
  className?: string;
}

function HeaderActions({ className = '' }: IHeaderActionProps) {
  const currentStoreId = useSelector(getStoreId);
  const storeToggleConfig = useRemoteConfig('storeToggle');
  const coachmarkConfig = useRemoteConfig('storeToggleCoachmark');

  const isDwebToggleEnabled = storeToggleConfig?.dweb?.enabled ?? false;
  const theme = storeToggleConfig?.dweb?.theme;

  if (!isDwebToggleEnabled || !theme) {
    return (
      <Container className={className}>
        <Search />
        <Auth />
        <WishList />
        <Cart />
      </Container>
    );
  }

  const {
    option1StoreId,
    option2StoreId,
    toggleImage1,
    toggleImage2,
    option1AriaLabel,
    option2AriaLabel,
  } = theme;

  return (
    <>
      {(coachmarkConfig?.enabled || coachmarkConfig?.homepageCoachmark?.enabled) && <StoreToggleCoachmark
        currentStoreId={currentStoreId}
        targetStoreId={option2StoreId}
        coachmarkConfig={coachmarkConfig}
      />}

      <Container className={className}>
        <Search />
        <StoreToggle
          currentStoreId={currentStoreId}
          option1StoreId={option1StoreId}
          option2StoreId={option2StoreId}
          toggleImage1={toggleImage1}
          toggleImage2={toggleImage2}
          option1AriaLabel={option1AriaLabel}
          option2AriaLabel={option2AriaLabel}
        />
        <Auth />
        <WishList />
        <Cart />
      </Container>
    </>
  );
}

export default memo(HeaderActions);
